module.exports = window["Bernie_l10nBundle_cs_CZ"];